import React from "react";

function ContactInfoSection() {
  return (
    <section className="contact-info-section section-padding fix">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-4 col-md-6">
            <div className="info-items">
              <div className="icon">
                <img src="assets/img/icon/19.svg" alt="location" />
              </div>
              <h3>Office Address</h3>
              <p>Lamka Court, Katani Rd, Syokimau, Kenya</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="info-items">
              <div className="icon">
                <img src="assets/img/icon/20.svg" alt="phone" />
              </div>
              <h3>Call Us For Support</h3>
              <p>
                <a href="tel:+254742940940">+254 742 940 940</a>
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="info-items">
              <div className="icon">
                <img src="assets/img/icon/21.svg" alt="email" />
              </div>
              <h3>Email Us Anytime</h3>
              <p>
                <a href="mailto:info@fayahtravels.com">info@fayahtravels.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactInfoSection;